var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRaffleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:4px;}.cls-2{stroke-linecap:round;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.47,20.49,15.1,33.84a.51.51,0,0,1-.7-.11L12.49,31.1a.39.39,0,0,1-.07-.35.81.81,0,0,1,.12-.28c2-1.89-.83-4.5-2.55-3.39-.11.07-.19.16-.36.08h0A.53.53,0,0,1,9.51,27l-2-2.73a.34.34,0,0,1,.08-.48L26.18,10.32a.43.43,0,0,1,.6.1l2,2.74,0,.18c-1.94,1.62.07,5,2.72,3.67l.11,0,2,2.75A.52.52,0,0,1,33.47,20.49Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.61,11a2.19,2.19,0,0,1-1.19-3l-.05-.18L18.43,6.13a.43.43,0,0,0-.59.15L9.61,20.54,6.82,25.38l-.45.77a.34.34,0,0,0,.12.47l1.9,1.09"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaffleIcon);
export default __webpack_public_path__ + "static/media/Raffle_Icon.e4615b165807b11d08988bec85ebbc7b.svg";
export { ForwardRef as ReactComponent };